import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {OperacionesComponent} from '../operaciones.component'
//Services
import {OperationService} from 'src/app/core/services/parameters/operation.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'create-modal',
  templateUrl: './create-modal.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CrearOperacionModal implements OnInit {

  newOperationForm: FormGroup;
  loading = false;
  showAlert = false;
  date = new Date();

  constructor(
    public dialogRef: MatDialogRef<OperacionesComponent>,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private operationService: OperationService
  ) {
  }

  ngOnInit(): void {
    this.newOperationForm = this.fb.group({
      operation: [, Validators.required]
    })
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.newOperationForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.newOperationForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.operation
      }
      this.operationService.createOperation(data).subscribe(_res => {
        this.alert.setNotice('Operación creada correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo crear la operación', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
